import { render, staticRenderFns } from "./TransactionalPopupDialog.vue?vue&type=template&id=36313a96&scoped=true&"
import script from "./TransactionalPopupDialog.vue?vue&type=script&lang=js&"
export * from "./TransactionalPopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./TransactionalPopupDialog.vue?vue&type=style&index=0&id=36313a96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36313a96",
  null
  
)

export default component.exports